export const dashboard_groups = {
  features_list: [
    {
      section_title: 'CMS',
      key_name: 'cms',
    },
    {
      section_title: `Experience your website as account owner (seller, campaign owner)
`,
      key_name: 'exp_as_account',
    },
    {
      section_title: `
Experience your website as customer (buyer, donor)`,
      key_name: 'exp_as_customer',
    },

    {
      section_title: 'Growing your Store traffic ',
      key_name: 'store_traffic',
    },
    {
      section_title: 'Support your Customers ',
      key_name: 'support_customer',
    },
    {
      section_title: 'Store Promotion to convert customers ',
      key_name: 'store_promotion',
    },

    {
      section_title: 'Advanced',
      key_name: 'advance',
    },
  ],
  tutorial_data: {
    title: 'Resource to get started',
    description: '',
    all_link: '/',
    video_list: [
      {
        title: 'Setting up Listings  ',
        link: 'https://www.youtube.com/embed/HzTNKhxQD4g?si=27OXhI9eWYiGC6S7',
        is_external_link: true,
      },
      {
        title: 'Listing Types',
        link: 'https://www.youtube.com/embed/KkWGazYGqGo?si=jPHfLQu0a7f75mOh',
        is_external_link: true,
      },
      {
        title: 'String Customisation',
        link: 'https://www.youtube.com/embed/V-CYBTXo7Fg?si=qjYOnTvnS32vcDqp',
        is_external_link: true,
      },
      {
        title: 'Configuring Stripe ',
        link: 'https://www.youtube.com/embed/s5miuwJRR-I?si=dfxYQPZRpolAX-MS',
        is_external_link: true,
      },
      {
        title: 'Shipping Charges',
        link: 'https://www.youtube.com/embed/UtQw-hib018?si=qwAG8VQ0kaYzDGuq',
        is_external_link: true,
      },
      {
        title: 'Configuring Tax',
        link: 'https://www.youtube.com/embed/qwOOsGvDUN4?si=iK7bkhV5AMkcL3Qf',
        is_external_link: true,
      },
    ],
  },
};

export const dashboard_default_data = [
  {
    title: 'Open Your website',
    description:
      'Website your end users sign in, sign up, make order, open account, etc.',
    link: '/',
    is_completed: false,
    is_external_link: true,
    external_link_by_domain: true,
    button_title: 'Open in New Tab',
    group_key: 'top_main',
    is_skipped: false,
  },
  {
    id: 'setup_shipping_service_method',
    title: 'Setup shipping / Service Method',
    link: '/delivery',
    is_completed: false,
    button_title: 'Configure Now',
    group_key: 'main',
    is_skipped: false,
  },
  {
    id: 'setup_payments',
    title: 'Setup payments',
    link: '/payments',
    is_completed: false,
    button_title: 'Configure Now',
    group_key: 'main',
    is_skipped: false,
  },
  {
    id: 'add_custom_domain',
    title: 'Add Custom Domain',
    link: 'https://tradly.app/workspace/domain',
    is_completed: false,
    is_external_link: true,
    description: 'Add your domain with no additional cost.',
    button_title: 'Configure Now',
    group_key: 'main',
    is_skipped: false,
  },
  {
    id: 'customize_website',
    title: 'Customize Website',
    link: 'https://tradly.app/editor',
    is_completed: false,
    is_external_link: true,
    description: 'For Advanced Users, Use Editor to  customize CSS.',
    button_title: 'Open editor',
    group_key: 'main',
    is_skipped: false,
  },
  {
    id: 'create_collection_of_listings',
    title: 'Create Collection of Listings',
    description: 'Helps increasing browsing experience and SEO',
    link: '/collections',
    is_completed: false,
    group_key: 'cms',
    is_skipped: false,
  },
  {
    id: 'create_custom_fields_for_listings',
    title: 'Create custom fields for your listings',
    description: 'to allow your users filter what they want.',
    link: '/listing-attributes',
    is_completed: false,
    group_key: 'cms',
    is_skipped: false,
  },
  {
    id: 'add_first_blog_post',
    title: 'Add your first blog post',
    description: 'to share about your product',
    link: 'https://tradly.app/workspace/blog',
    is_completed: false,
    is_external_link: true,
    group_key: 'cms',
    is_skipped: false,
  },
  {
    id: 'add_business_pages',
    title: 'Add your business pages',
    description: 'like terms, about us, privacy policy.',
    link: 'https://tradly.app/workspace/p',
    is_completed: false,
    is_external_link: true,
    group_key: 'cms',
    is_skipped: false,
  },
  {
    id: 'connect_google_search',
    title: 'Connect your website with Google Search',
    description: 'to let google know about your website',
    link: 'https://tradly.app/workspace/integrations/google-search-console',
    is_completed: false,
    is_external_link: true,
    group_key: 'store_traffic',
    is_skipped: false,
  },
  {
    id: 'integrate_google_analytics',
    title: 'Integrate Google Analytics',
    description: 'to analyze user behaviour',
    link: 'https://tradly.app/workspace/integrations/google-analytics',
    is_completed: false,
    is_external_link: true,
    group_key: 'store_traffic',
    is_skipped: false,
  },
  {
    id: 'add_whatsapp_support',
    title: 'Add WhatsApp Support in your website',
    description: '',
    link: 'https://tradly.app/workspace/integrations/whatsapp-button',
    is_completed: false,
    is_external_link: true,
    group_key: 'support_customer',
    is_skipped: false,
  },
  {
    id: 'add_advanced_livechat',
    title: 'Add any advanced LiveChat',
    description: '',
    link: 'https://tradly.app/workspace/integrations?category_id=5137',
    is_completed: false,
    is_external_link: true,
    group_key: 'support_customer',
    is_skipped: false,
  },
  {
    id: 'create_first_coupon',
    title: 'Create your first coupon',
    description: '',
    link: '/coupon',
    is_completed: false,
    group_key: 'store_promotion',
    is_skipped: false,
  },
  {
    id: 'add_promotional_images',
    title: 'Add a Promotional Images',
    description: 'used for slider in homepage',
    link: '/promotions',
    is_completed: false,
    group_key: 'store_promotion',
    is_skipped: false,
  },
  {
    id: 'connect_with_zapier',
    title: 'Connect with Zapier ',
    description: 'if you want send data to other tools',
    link: 'https://tradly.app/workspace/webhooks?page=1',
    is_completed: false,
    is_external_link: true,
    group_key: 'advance',
    is_skipped: false,
  },
  {
    id: 'customize_emails',
    title: 'Customize your Emails',
    description:
      'if you want to change welcome email, OTP, order emails. HTML supported',
    link: '/communications',
    is_completed: false,
    group_key: 'advance',
    is_skipped: false,
  },
  {
    id: 'show_videos',
    title: 'Show videos',
    is_completed: false,
    is_skipped: false,
  },
  {
    id: 'register_as_user',
    title: 'Register as a User',
    description: 'Act like a customer and test',
    link: `/sign-up`,
    is_completed: false,
    is_external_link: true,
    external_link_by_domain: true,
    group_key: 'exp_as_account',
    is_skipped: false,
  },
  {
    id: 'create_test_seller_account',
    title: 'Create an Account',
    description: 'Open a test seller account',
    link: `/a/create-account`,
    is_completed: false,
    is_external_link: true,
    external_link_by_domain: true,
    group_key: 'exp_as_account',
    is_skipped: false,
  },
  {
    id: 'start_posting_listings',
    title: 'Start posting listings',
    description: 'create test listings',
    link: `/a/my-account`,
    is_completed: false,
    is_external_link: true,
    external_link_by_domain: true,
    group_key: 'exp_as_account',
    is_skipped: false,
  },
  {
    id: 'register_as_customer',
    title: 'Register as a User',
    description: 'Act like a customer and test',
    link: `/sign-up`,
    is_completed: false,
    is_external_link: true,
    external_link_by_domain: true,
    group_key: 'exp_as_customer',
    is_skipped: false,
  },
  {
    id: 'create_customer_account',
    title: 'Create an Account',
    description: 'Open an account to start post listings.',
    link: `/a/create-account`,
    is_completed: false,
    is_external_link: true,
    external_link_by_domain: true,
    group_key: 'exp_as_customer',
    is_skipped: false,
  },
  {
    id: 'make_order',
    title: 'Make Order',
    description: 'to see how order and checkout flow works',
    link: `/l`,
    is_completed: false,
    is_external_link: true,
    external_link_by_domain: true,
    group_key: 'exp_as_customer',
    is_skipped: false,
  },
  {
    id: 'add_to_wishlist',
    title: 'Add item to wish list',
    description: '',
    link: `/l`,
    is_completed: false,
    is_external_link: true,
    external_link_by_domain: true,
    group_key: 'exp_as_customer',
    is_skipped: false,
  },
  {
    id: 'view_orders',
    title: 'View Orders',
    description: 'to know the status of your customers orders',
    link: '/orders',
    is_completed: false,
    group_key: 'exp_as_customer',
    is_skipped: false,
  },
];
